<template>
    <component :is="currentComponent"></component>    
</template>

<script>
import NationalReport from './National Report/NationalReport';
import LogReport from './Log_Report/LogReport';
import LogReportDetails from './Log_Report/LogReportDetails';
import MappingReport from './Mapping Report/MappingReport';
import ObjectSearchDetail from './Mapping Detail/ObjectSearchDetail';
import UserManagement from './User Management/UserManagement';
import ReplacedQR from './Replaced QR/ReplacedQR';
import EditUser from './User Management/childComponents/EditUser';
import AddUser from './User Management/childComponents/AddUser';
import VehicleDetail from './Mapping Detail/VehicleDetail';
import IncomingPDC from './IncomingPDC/IncomingPDC';
import Highlights from './Highlights/Highlights'
import UnmatchReport from './Unmatch Report/UnmatchReport';
import AgingReport from './Aging Report/AgingReport';
import LeadTime from './Lead Time/LeadTime';
import ProductPlan from './Product Plan/ProductPlan';
import DealerService from './DealerService/DealerService';
import DealerRegistrationAndService from './DealerRegistrationAndService/DealerRegistrationAndService';

export default {
    components : {
        NationalReport,
        LogReport,
        LogReportDetails,
        MappingReport,
        ObjectSearchDetail,
        UserManagement,
        EditUser,
        AddUser,
        VehicleDetail,
        IncomingPDC,
        Highlights,
        UnmatchReport,
        AgingReport,
        LeadTime,
        ReplacedQR,
        ProductPlan,
        DealerService,
        DealerRegistrationAndService
    },
    data(){
        return{
            currentComponent : ''
        }
    },
    mounted(){
        //get current route to import component name
        this.currentComponent = this.$route.name;
        
        //for now only
        // this.currentComponent = 'NationalReport';
    },
    watch : {
        '$route.name' : function(){
            this.currentComponent = this.$route.name;
        }
    }
}
</script>